var map = {
	"./A1.png": 3881,
	"./A2.png": 2517,
	"./A3.png": 289,
	"./A4.png": 5424,
	"./A5.png": 4474,
	"./A6.png": 8499,
	"./AIGC2x.png": 5666,
	"./AIGC_large.svg": 9686,
	"./AIGC_large.webp": 4559,
	"./Frame.svg": 6785,
	"./Group137.svg": 9024,
	"./Group137_1.svg": 1920,
	"./Group137_1.webp": 1772,
	"./Group138.svg": 3452,
	"./Group139.svg": 8478,
	"./Group139.webp": 4949,
	"./Group139_1.svg": 7434,
	"./Group139_1.webp": 2367,
	"./Group_137.webp": 7617,
	"./Group_138.webp": 7729,
	"./Group_138_1.webp": 4108,
	"./about.png": 4722,
	"./ai/AIGC.png": 1465,
	"./ai/Group52.png": 404,
	"./ai/Group52_1.png": 9687,
	"./ai/Group53.png": 8123,
	"./ai/Group53_1.png": 8254,
	"./ai/Group54.png": 9661,
	"./ai/Group54_1.png": 5887,
	"./ai/Group55.png": 1015,
	"./ai/Group55_1.png": 2011,
	"./ai/Group56.png": 4515,
	"./ai/Group56_1.png": 4916,
	"./ai/solution1.png": 7269,
	"./ai/solution2.png": 4589,
	"./ai/solution3.png": 4937,
	"./ai/一站式.png": 3205,
	"./ai/多元化.png": 5422,
	"./ai/性价比.png": 9002,
	"./ai/高性能加持.png": 8905,
	"./back.png": 84,
	"./bottom_bg.png": 5702,
	"./logo.svg": 9574,
	"./mail.png": 9698,
	"./news/news.jpg": 6028,
	"./news/广告图.png": 6962,
	"./service/1.png": 7813,
	"./service/2.png": 9286,
	"./service/3.png": 7454,
	"./service/4.png": 4560,
	"./service/AIGC.png": 8992,
	"./service/Group106.png": 7322,
	"./service/Group107.png": 8413,
	"./service/Group108.png": 3737,
	"./service/Group109.png": 3624,
	"./service/Group110.png": 8872,
	"./service/Group1101.png": 3032,
	"./service/Group1102.png": 1786,
	"./service/Group1103.png": 5878,
	"./service/Group1104.png": 7106,
	"./service/Group1105.png": 1523,
	"./service/Group1106.png": 7865,
	"./service/Group111.png": 9148,
	"./service/Group119.png": 9617,
	"./service/Group120.png": 3773,
	"./service/Group121.png": 4476,
	"./service/Group126.png": 4786,
	"./service/arrow.png": 8054,
	"./service/云产品.png": 8415,
	"./service/云游戏1.png": 713,
	"./service/云电脑.png": 7749,
	"./service/前景覆层.png": 1395,
	"./service/背景装饰.png": 8261,
	"./service/背景装饰2.png": 6059,
	"./service/装饰1.png": 2266,
	"./solution/Group52.png": 8119,
	"./solution/Group52_1.png": 1600,
	"./solution/Group53.png": 9942,
	"./solution/Group53_1.png": 5545,
	"./solution/Group54.png": 4333,
	"./solution/Group54_1.png": 3588,
	"./solution/Group55.png": 2733,
	"./solution/Group55_1.png": 2847,
	"./solution/Group56.png": 7644,
	"./solution/Group56_1.png": 2519,
	"./solution/icon_1.png": 7885,
	"./solution/icon_10.png": 4417,
	"./solution/icon_11.png": 9405,
	"./solution/icon_12.png": 8426,
	"./solution/icon_13.png": 1607,
	"./solution/icon_14.png": 4942,
	"./solution/icon_15.png": 3003,
	"./solution/icon_16.png": 2993,
	"./solution/icon_17.png": 7864,
	"./solution/icon_2.png": 1436,
	"./solution/icon_3.png": 7017,
	"./solution/icon_4.png": 4690,
	"./solution/icon_5.png": 953,
	"./solution/icon_6.png": 1606,
	"./solution/icon_7.png": 8309,
	"./solution/icon_8.png": 9623,
	"./solution/icon_9.png": 260,
	"./solution/一键.png": 2114,
	"./solution/云游戏.png": 4612,
	"./solution/传感器.png": 6069,
	"./solution/前景覆层.png": 222,
	"./solution/发行.png": 3220,
	"./solution/启动.png": 6279,
	"./solution/平台.png": 6665,
	"./solution/微端.png": 5777,
	"./solution/控制权.png": 4143,
	"./solution/支付.png": 3988,
	"./solution/文件.png": 2121,
	"./solution/更新.png": 748,
	"./solution/游戏.png": 2328,
	"./solution/画质.png": 8448,
	"./solution/直播.png": 5934,
	"./solution/背景装饰.png": 6747,
	"./solution/适配.png": 3815,
	"./solutionCloudGame/Group52.png": 4314,
	"./solutionCloudGame/Group52_1.png": 844,
	"./solutionCloudGame/Group53.png": 1169,
	"./solutionCloudGame/Group53_1.png": 1569,
	"./solutionCloudGame/Group54.png": 1674,
	"./solutionCloudGame/Group54_1.png": 3552,
	"./solutionCloudGame/Group55.png": 9307,
	"./solutionCloudGame/Group55_1.png": 9088,
	"./solutionCloudGame/Group56.png": 5706,
	"./solutionCloudGame/Group56_1.png": 8251,
	"./solutionCloudGame/云电脑.png": 8863,
	"./solutionCloudGame/多终端.png": 9679,
	"./solutionCloudGame/平台.png": 9243,
	"./solutionCloudGame/微端.png": 519,
	"./solutionCloudGame/游戏.png": 9992,
	"./solutionCloudGame/简单.png": 3094,
	"./solutionCloudGame/轻量化.png": 387,
	"./solutionCloudGame/高性能.png": 6809,
	"./中国地图.svg": 5981,
	"./主视觉.svg": 6090,
	"./云平台.svg": 662,
	"./云游戏.webp": 5595,
	"./云电脑.webp": 6379,
	"./优化.svg": 7513,
	"./内容.svg": 9489,
	"./前景覆层.svg": 7040,
	"./协同.svg": 7634,
	"./卫星.png": 6690,
	"./发行.svg": 9906,
	"./可靠.svg": 9159,
	"./大模型.svg": 7121,
	"./宇航员.svg": 7433,
	"./微端.svg": 5826,
	"./成本.svg": 1542,
	"./文案.svg": 594,
	"./新闻背景.svg": 1812,
	"./新闻背景.webp": 7162,
	"./方案.svg": 8797,
	"./时效.svg": 6689,
	"./桌面.svg": 542,
	"./游戏2x.png": 5347,
	"./游戏_large.svg": 8482,
	"./灵活.svg": 9974,
	"./电脑2x.png": 1995,
	"./直播.svg": 711,
	"./科幻背景.png": 9593,
	"./科幻背景.svg": 6667,
	"./网吧.svg": 441,
	"./背景.svg": 5524,
	"./背景图.svg": 5577,
	"./背景层.svg": 8470,
	"./背景层.webp": 1574,
	"./资源.svg": 3053,
	"./酒店.svg": 657,
	"./里程碑背景.svg": 5770,
	"./飞船.svg": 5730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;